module.exports = {
	"id": "JO",
	"name": "Jordan",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": 0.004426,
			"7": 0.004426,
			"8": 0.008852,
			"9": null,
			"10": null,
			"11": 0.026556,
			"12": 0.013278,
			"13": 0.008852,
			"14": null,
			"15": 0.008852,
			"16": 0.008852,
			"17": 0.004426,
			"18": 0.017704,
			"19": 0.013278,
			"20": 0.008852,
			"21": 0.008852,
			"22": 0.026556,
			"23": 0.02213,
			"24": 0.017704,
			"25": 0.013278,
			"26": 0.013278,
			"27": 0.035408,
			"28": 0.026556,
			"29": 0.053112,
			"30": 0.057538,
			"31": 0.172614,
			"32": 0.026556,
			"33": 0.163762,
			"34": 0.017704,
			"35": 0.013278,
			"36": 0.013278,
			"37": 0.017704,
			"38": 0.035408,
			"39": 0.026556,
			"40": 0.04426,
			"41": 0.026556,
			"42": 0.026556,
			"43": 0.239004,
			"44": 0.053112,
			"45": 0.039834,
			"46": 0.030982,
			"47": 0.101798,
			"48": 0.08852,
			"49": 1.584508,
			"50": 0.115076,
			"51": 0.628492,
			"52": 2.531672,
			"53": 18.797222,
			"54": 6.435404,
			"55": 0.06639,
			"56": 0.017704,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.008852,
			"4": 0.004426,
			"5": null,
			"6": 0.004426,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.008852,
			"11": 0.008852,
			"12": 0.008852,
			"13": 0.008852,
			"14": 0.008852,
			"15": null,
			"16": 0.004426,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": 0.004426,
			"28": 0.004426,
			"29": 0.008852,
			"30": 0.008852,
			"31": 0.004426,
			"32": null,
			"33": 0.017704,
			"34": 0.013278,
			"35": 0.026556,
			"36": 0.013278,
			"37": 0.008852,
			"38": 0.030982,
			"39": 0.013278,
			"40": 0.017704,
			"41": 0.017704,
			"42": 0.013278,
			"43": 0.119502,
			"44": 0.048686,
			"45": 0.061964,
			"46": 0.06639,
			"47": 0.371784,
			"48": 0.393914,
			"49": 2.664452,
			"50": 0.146058,
			"51": null,
			"52": 0.02213,
			"3.5": null,
			"3.6": 0.017704
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": 0.008852,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.017704,
			"37": 0.030982,
			"38": 0.057538,
			"39": 0.008852,
			"40": 0.469156,
			"41": 0.057538,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.013278
		},
		"safari": {
			"0": null,
			"4": 0.004426,
			"5": 0.013278,
			"6": 0.013278,
			"7": 0.013278,
			"8": 0.057538,
			"9": 0.08852,
			"10": 0.438174,
			"3.1": null,
			"3.2": null,
			"5.1": 0.039834,
			"6.1": 0.026556,
			"7.1": null,
			"9.1": 0.367358
		},
		"ios_saf": {
			"8": 0,
			"10": 4.28970654288,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.115602627602,
			"8.1-8.4": 0.213570956078,
			"9.0-9.2": 0.101887061615,
			"9.3": 1.55443081182
		},
		"android": {
			"3": 0,
			"4": 0.119553090439,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0149441363049,
			"4.1": 0.431245076227,
			"4.2-4.3": 1.07811269057,
			"4.4": 2.47218712016,
			"4.4.3-4.4.4": 2.4935358863
		},
		"ie": {
			"6": 0.0180347098381,
			"7": 0.0180347098381,
			"8": 0.789018555417,
			"9": 0.392254938979,
			"10": 0.302081389788,
			"11": 2.10104369614,
			"5.5": null
		},
		"op_mob": {
			"0": 0.124906867114,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0034696351976
		},
		"edge": {
			"12": 0.075242,
			"13": 0.26556,
			"14": 0.416044
		},
		"ie_mob": {
			"10": 0.180219830986,
			"11": 0.733752169014
		},
		"bb": {
			"7": 0.0083595,
			"10": null
		},
		"samsung": {
			"0": 5.160598
		},
		"and_uc": {
			"0": 1.437834
		},
		"op_mini": {
			"0": 1.68284849769
		},
		"and_chr": {
			"0": 34.662382
		},
		"and_ff": {
			"0": 0.022292
		}
	},
	"total": 98.9041785
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/JO.json
 ** module id = 558
 ** module chunks = 0
 **/